// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__SDNrl","footerTop":"Footer_footerTop__hXfeQ","box":"Footer_box__zIjKw","imgBox":"Footer_imgBox__Xn47n","aboutUs":"Footer_aboutUs__tKFSs"};